var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-user-input-wrapper", class: { disabled: _vm.disabled } },
    [
      _c("Suggestions", {
        attrs: { colors: _vm.colors, suggestions: _vm.suggestions },
        on: { sendSuggestion: _vm._submitSuggestion },
      }),
      _vm._v(" "),
      _vm.file
        ? _c(
            "div",
            {
              staticClass: "file-container",
              style: {
                backgroundColor: _vm.colors.userInput.text,
                color: _vm.colors.userInput.bg,
              },
            },
            [
              _c("span", { staticClass: "icon-file-message" }, [
                _c("img", {
                  attrs: {
                    alt: _vm.icons.file.name,
                    src: _vm.icons.file.img,
                    height: "15",
                  },
                }),
              ]),
              _vm._v("\n        " + _vm._s(_vm.file.name) + "\n        "),
              _c(
                "span",
                {
                  staticClass: "delete-file-message",
                  on: {
                    click: function ($event) {
                      return _vm.cancelFile()
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      alt: _vm.icons.closeSvg.name,
                      src: _vm.icons.closeSvg.img,
                      height: "10",
                      title: _vm.$t("message.removeAttachedFile"),
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "sc-user-input",
          class: { active: _vm.inputActive },
          style: { background: _vm.colors.userInput.bg },
        },
        [
          _c("div", {
            ref: "userInput",
            staticClass: "sc-user-input--text",
            style: { color: _vm.colors.userInput.text },
            attrs: {
              id: _vm.id,
              placeholder: _vm.placeholder,
              autofocus: "",
              contentEditable: true,
              role: "button",
              tabIndex: "0",
            },
            on: {
              blur: function ($event) {
                return _vm.setInputActive(false)
              },
              focus: function ($event) {
                return _vm.setInputActive(true)
              },
              focusUserInput: function ($event) {
                return _vm.focusUserInput()
              },
              keydown: _vm.handleKey,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sc-user-input--buttons" }, [
            _vm.showEmoji && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button emoji" },
                  [
                    _c("EmojiIcon", {
                      staticClass: "btnEmoji",
                      attrs: {
                        color: _vm.colors.userInput.text,
                        onEmojiPicked: _vm._handleEmojiPicked,
                        disabled: _vm.disabled,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showFile && !_vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c("FileIcons", {
                      attrs: {
                        color: _vm.colors.userInput.text,
                        onChange: _vm._handleFileSubmit,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing
              ? _c(
                  "div",
                  { staticClass: "sc-user-input--button" },
                  [
                    _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "cancel",
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm._editFinish.apply(null, arguments)
                          },
                        },
                      },
                      [_c("icon-cross")],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sc-user-input--button" },
              [
                _vm.isEditing
                  ? _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Edit",
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm._editText.apply(null, arguments)
                          },
                        },
                      },
                      [_c("icon-ok")],
                      1
                    )
                  : _c(
                      "user-input-button",
                      {
                        attrs: {
                          color: _vm.colors.userInput.text,
                          tooltip: "Send",
                          "new-icon": true,
                          disabled: _vm.disabled,
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm._submitText.apply(null, arguments)
                          },
                        },
                      },
                      [_c("icon-send")],
                      1
                    ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }